import type { TranslationSchema } from '../pt-BR';
import type { DeepPartialStrings } from '../types';

export const categories = {
    layout: {
        listTitle: 'Categories',
        newTitle: 'New Category',
        editTitle: 'Edit Category',
    },
    list: {
        expensesTab: 'Expenses',
        incomeTab: 'Income',
        subcategoryCount_one: '{{count}} subcategory',
        subcategoryCount_other: '{{count}} subcategories',
        emptyTitle: 'No categories',
        emptySubtitle: 'Add a new category',
        emptyAction: 'Add',
    },
    form: {
        nameLabel: 'Category name',
        namePlaceholder: 'e.g. Groceries',
        typeLabel: 'Type',
        typeExpense: 'Expense',
        typeIncome: 'Income',
        colorLabel: 'Color',
        iconLabel: 'Icon',
        subcategoriesLabel: 'Subcategories',
        cancelEditAccessibility: 'Cancel editing',
        saveSubcategoryAccessibility: 'Save subcategory',
        editSubcategoryAccessibility: 'Edit subcategory {{name}}',
        renameSubcategoryAccessibility: 'Rename {{name}}',
        removeSubcategoryAccessibility: 'Remove {{name}}',
        reorderSubcategoriesAccessibility: 'Reorder subcategories',
        saveSubcategoryOrderAccessibility: 'Save subcategory order',
        moveSubcategoryUpAccessibility: 'Move {{name}} up',
        moveSubcategoryDownAccessibility: 'Move {{name}} down',
        newSubcategoryPlaceholder: 'New subcategory...',
        archiveAction: 'Archive category',
        unarchiveAction: 'Unarchive category',
        mergeAction: 'Merge with another category',
        deleteAction: 'Delete category',
        moreOptionsAccessibility: 'Category options',
        createAccessibility: 'Create category',
        saveAccessibility: 'Save',
        colorSheetTitle: 'Choose a color',
        iconSheetTitle: 'Choose an icon',
    },
    archiveDialog: {
        archiveTitle: 'Archive category',
        unarchiveTitle: 'Unarchive category',
        archiveMessage: 'The category will be hidden, but existing transactions will be kept.',
        unarchiveMessage: 'The category will appear in lists again.',
        archiveConfirm: 'Archive',
        unarchiveConfirm: 'Unarchive',
    },
    deleteDialog: {
        title: 'Delete category',
        // {{txCount}} instead of {{count}} on purpose: the "(s)" is literal in the
        // current copy — count would trigger i18next pluralization and change the message.
        messageWithTransactions: '"{{name}}" has {{txCount}} transaction(s). Deleting it will move them to "{{fallbackName}}". This action can\'t be undone.',
        message: 'Delete "{{name}}"? This action can\'t be undone.',
        confirm: 'Delete',
    },
    mergeDialog: {
        title: 'Merge category',
        message: 'All transactions and subcategories from this category will be moved to the target category. This action can\'t be undone.',
        confirm: 'Choose target',
    },
    mergeSuccessDialog: {
        title: 'Merged',
        message: '{{txCount}} transaction(s) moved to the target category.',
        confirm: 'OK',
    },
    deleteSubcategoryDialog: {
        title: 'Remove subcategory',
        message: 'Remove "{{name}}"? Linked transactions will be left without a subcategory.',
        confirm: 'Remove',
    },
    selector: {
        expenseTitle: 'Expense Categories',
        incomeTitle: 'Income Categories',
        searchPlaceholder: 'Search category...',
        noSubcategory: 'No subcategory',
        openCategory: 'View subcategories of {{name}}',
        emptySubcategoriesHint: 'No subcategories yet. Tap + to create the first one.',
        newSubcategoryPlaceholder: 'Subcategory name',
        deleteSubcategoryTitle: 'Remove subcategory',
        deleteSubcategoryMessage: 'Remove "{{name}}"? Linked transactions will be left without a subcategory.',
        cancelButton: 'Cancel',
        removeButton: 'Remove',
    },
} satisfies DeepPartialStrings<TranslationSchema['categories']>;
